import axios from 'axios';
import { baseUrl, baseUrl1 } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');

export const getJobinfostatus = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + 'api/master/getJobInfoStatus', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the jobinfo_status:', error);
        throw error;
    }
};

//-------------------------****Api Calls for Production report (fetch, exportExcel)****-------------------------//

export const fetchProductionData = async (pageNo: any, pageSize: any, brokerId: any, fromDate: any, toDate: any, status: any, isExport: any, ComplianceId: number) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const brokerParam = brokerId === 'All' ? 0 : brokerId;
        const statusParam = status === 'All' ? 0 : status;

        let url = `${baseUrl}api/Report/GetproductionReport?pageNo=${pageNo}&pageSize=${pageSize}&brokerId=${brokerParam}&Status=${statusParam}&ComplianceId=${ComplianceId}`;

        if (fromDate) {
            url += `&fromDate=${fromDate}`;
        }

        if (toDate) {
            url += `&toDate=${toDate}`;
        }

        if (isExport) {
            url += `&isExport=false`;
        }

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching productiondata:', error);
        throw error;
    }
};


export const generateExportExcelforProduction = async (brokerId: any, fromDate: any, toDate: any, status: any, ComplianceId: number) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const brokerParam = brokerId === 'All' ? 0 : brokerId;
        const statusParam = status === 'All' ? 0 : status;

        let url = `${baseUrl}api/Report/ExportProductionReport?brokerId=${brokerParam}&Status=${statusParam}&ComplianceId=${ComplianceId}`;

        if (fromDate) {
            url += `&fromDate=${fromDate}`;
        }

        if (toDate) {
            url += `&toDate=${toDate}`;
        }

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

//----------------------------------------------------------------------------------------------------------------------//


//-------------------------****Api Calls for File_upload_details report (fetch, exportExcel)****-------------------------//

export const fetchFileUploadDetailsData = async (pageNo: any, pageSize: any, brokerId: any, fromDate: any, toDate: any, isExport: any, ComplianceId: number) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const brokerParam = brokerId === 'All' ? 0 : brokerId;

        let url = `${baseUrl}api/Report/GetfileUploaddetailReport?pageNo=${pageNo}&pageSize=${pageSize}&brokerId=${brokerParam}&ComplianceId=${ComplianceId}`;

        if (fromDate) {
            url += `&fromDate=${fromDate}`;
        }

        if (toDate) {
            url += `&toDate=${toDate}`;
        }

        if (isExport) {
            url += `&isExport=false`;
        }

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching filedetails_data:', error);
        throw error;
    }
};


export const generateExportExcelforFileUploadDetails = async (brokerId: any, fromDate: any, toDate: any, ComplianceId: number) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const brokerParam = brokerId === 'All' ? 0 : brokerId;

        let url = `${baseUrl}api/Report/ExportFileUploadDetailsReport?brokerId=${brokerParam}&ComplianceId=${ComplianceId}`;

        if (fromDate) {
            url += `&fromDate=${fromDate}`;
        }

        if (toDate) {
            url += `&toDate=${toDate}`;
        }
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading FileUploadDetails:', error);
        throw error;
    }
};
//----------------------------------------------------------------------------------------------------------------------//

//-------------------------****Api Calls for Pivot Table report (fetch, exportExcel)****-------------------------//

export const getPivotReport = async (pageNo: any, pageSize: any, fromDate: any, toDate: any) => {   //Get API to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(
            `${baseUrl}api/Report/GetPivotReport?pageNo=${pageNo}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&isExport=false`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching pivot report:', error);
        throw error;
    }
};


export const exportPivotReport = async (fromDate?: string, toDate?: string) => {        //API claa for ExportExcel
    try {

        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(
            `${baseUrl}api/Report/ExportPivotReport${fromDate && toDate ? `?fromDate=${fromDate}&toDate=${toDate}` : ''}`,
            {
                responseType: 'blob', // important to get file as Blob
                headers: {
                    Authorization: `Bearer ${Token}`, // add your auth token logic here
                },
            }
        );
        return response.data; // Blob
    } catch (error) {
        console.error('Failed to export pivot report:', error);
        throw error;
    }
};

//----------------------------------------------------------------------------------------------------------------------//


//-------------------------****Api Calls for Overall Status Report (fetch, exportExcel)****-------------------------//

export const fetchOverallStatusReport = async (pageNo: any, pageSize: any, fromDate: any, toDate: any, ComplianceId: number) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/GetOverallStatusReport?pageNo=${pageNo}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&isExport=false&ComplianceId=${ComplianceId}`;
        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching Overall Status Report:', error);
        throw error;
    }
};


export const generateExportOverallStatusReport = async (fromDate: any, toDate: any, ComplianceId: number) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/ExportOverallStatusReport?fromDate=${fromDate}&toDate=${toDate}&ComplianceId=${ComplianceId}`;
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error in downloading Overal lStatus Report :', error);
        throw error;
    }
};
//----------------------------------------------------------------------------------------------------------------------//


//-------------------------****Api Calls for Acord Json Data (fetch, exportExcel)****-------------------------//

export const fetchAcordJsonData = async (jobid: any, pageNo: any, pageSize: any) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/GetAcordJsonData?jobId=${jobid}&pageNo=${pageNo}&pageSize=${pageSize}&isExport=false`;
        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching AcordJson Data:', error);
        throw error;
    }
};

export const generateExportAcordJsonData = async (jobid: any) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/ExportAcordJsonData?jobId=${jobid}`;
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });
        return response?.data;
    } catch (error) {
        console.error('Error in downloading  Acord Json Data:', error);
        throw error;
    }
};


//----------------------------------------------------------------------------------------------------------------------//


//-------------------------****Api Calls for Auto Job LOB Mapping Rereport (fetch, exportExcel)****-------------------------//

export const fetchAutoJobLOBMappingReport = async (pageNo: any, pageSize: any) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/GetAutoJobLOBMappingReport?pageNo=${pageNo}&pageSize=${pageSize}&isExport=false`;
        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching Auto Job LOB Mapping Report:', error);
        throw error;
    }
};

export const generateExportAutoJobLOBMappingReport = async () => { //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        let url = `${baseUrl}api/Report/ExportAutoJobLOBMappingReport`;
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error in downloading Auto Jo LOB Mapping Report:', error);
        throw error;
    }
};


export const fetchJobGenerationErrors = async (jobId: string): Promise<string[]> => {
    try {
        if (!jobId?.trim()) {
            return ["Job ID cannot be empty"];
        }

        // Get or refresh token
        let Token = sessionStorage.getItem("token");
        Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        // Construct URL
        const url = `${baseUrl}api/Report/getJobGenerationErrors?jobId=${encodeURIComponent(jobId)}`;

        // API call
        const response = await axios.get<string[]>(url, {
            headers: {
                'Authorization': `Bearer ${Token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status !== 200) {
            return ["Failed to fetch errors. Please try again."];
        }

        // Ensure it's a valid array
        return Array.isArray(response.data) ? response.data : ["Unexpected response format."];

    } catch (error) {
        console.error('Error fetching job generation errors:', error);
        return ["Failed to fetch errors. Please try again."];
    }
};

export const ExportAutoDispatchSTP = async () => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/Report/ExportAutoDispatchSTP`;
        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading FileUploadDetails:', error);
        throw error;
    }
};